import {
    apiFriendship,
    apiMarketStatus
} from "../../api/global.js";

import * as constant from './constant'
export const actions = {
    async saveMarketActiveTab({ commit }, name) {
        await commit(constant.MARKET_ACTIVE_ROUTE, name)
    },
    async findFriendship({ commit }, access_token) {
        const rs = await apiFriendship(access_token);
        if (rs && rs.status == 200) {
            let data = rs.data
            return data
        }
    },
    async saveMarketActiveTabChild({ commit }, name) {
        await commit(constant.MARKET_ACTIVE_ROUTE_CHILD, name)
    },
    async fetchMarketStatus({ commit }, payload) {
        const rs = await apiMarketStatus();
        if (rs && rs.status == 200) {
            let data = rs.data
            if (data && typeof (data) !== 'string') {
                if (payload === 'currency') return data.currencies.fx
                else return data.currencies.crypto
            }
        }
    },
}